import { defineMessages } from 'react-intl';

export default defineMessages({
  exitEmergencyMode: {
    id: 'app.components.ExitEmergencyMode.exitEmergencyMode',
    defaultMessage: 'Exit emergency mode',
  },
  exitEmergencyModeSuccess: {
    id: 'app.components.ExitEmergencyMode.exitEmergencyModeSuccess',
    defaultMessage: 'Emergency mode successfully exited',
  },
  exitEmergencyModeFailure: {
    id: 'app.components.ExitEmergencyMode.exitEmergencyModeFailure',
    defaultMessage: 'Failed exiting emergency mode',
  },
  exitEmergencyModeModalTitle: {
    id: 'app.components.ExitEmergencyMode.exitEmergencyModeModalTitle',
    defaultMessage: 'Are you sure you want to exit the emergency mode?',
  },
  exitEmergencyModeModalDescription: {
    id: 'app.components.ExitEmergencyMode.exitEmergencyModeModalDescription',
    defaultMessage:
      'Exiting the emergency mode will inform publishers that the emergency situation is over and will reset the emergency status of all affected publishers',
  },
  exitEmergencyModeModalCancel: {
    id: 'app.components.ExitEmergencyMode.exitEmergencyModeModalCancel',
    defaultMessage: 'No, stay in emergency mode',
  },
  exitEmergencyModeModalConfirm: {
    id: 'app.components.ExitEmergencyMode.exitEmergencyModeModalConfirm',
    defaultMessage: 'Yes, exit emergency mode',
  },
});
